export class ManuallySetStatus {
  public static readonly type = '[Network] ManuallySetStatus';
  constructor(public readonly newStatus: boolean) {}
}
